// eslint-disable-next-line func-names
export default function ({ app, req }) {
    if (process.server) {
        const cfIpcountry = req.headers['x-ip-country'];
        if ((cfIpcountry === null || cfIpcountry === void 0 ? void 0 : cfIpcountry.length) > 0)
            app.$cookies.set('cf-ipcountry', cfIpcountry);
    }
}
